import { render, staticRenderFns } from "./EszigRedirect.vue?vue&type=template&id=e15ed136&"
import script from "./EszigRedirect.vue?vue&type=script&lang=js&"
export * from "./EszigRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports